var map = {
	"./browser-notice.de-CH.json": 1021,
	"./browser-notice.de-DE.json": 1022,
	"./browser-notice.en-CA.json": 1023,
	"./browser-notice.en-GB.json": 1024,
	"./browser-notice.en-IN.json": 1025,
	"./browser-notice.en-ME.json": 1026,
	"./browser-notice.en-US.json": 1027,
	"./browser-notice.es-EM.json": 1028,
	"./browser-notice.es-ES.json": 1029,
	"./browser-notice.fr-BE.json": 1030,
	"./browser-notice.fr-CA.json": 1031,
	"./browser-notice.fr-CH.json": 1032,
	"./browser-notice.nl-BE.json": 1033,
	"./browser-notice.nl-NL.json": 1034,
	"./browser-notice.pl-PL.json": 1035,
	"./browser-notice.pt-BR.json": 1036
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1020;